export const GRANTED = "granted";
export const DENIED = "denied";
export const DEFAULT = "default";
export const PUSH_NOTIFICATIONS_SETTINGS_KEY = "__PUSH_NOTIFICATIONS_SETTINGS__";
export const PUSH_NOTIFICATIONS_PLATFORM = "web";
